<template>
  <el-dialog class="demand_model_dialog" top="5vh" center :title="newTitle" width="80%" :before-close="handleClose"
             :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <el-form-item label="催单记录" prop="background" :label-width="formLabelWidth">
        <div class="re_list">
        <div v-for="item in reminder_list">
          {{item.create_time}}  {{item.creator.nameZh}}({{item.creator.nameEn}})  催单成功
          <div> {{item.desc}}</div>
        </div>
        </div>
      </el-form-item>
      <el-form-item label="描述" prop="desc" :label-width="formLabelWidth" v-if="isCreateUser">
        <el-input type="textarea"  :autosize="{ minRows: 6, maxRows: 16 }"
                  placeholder="请输入描述" v-model="form.desc">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button  type="warning" :loading="loading.submit"  @click="onSubmit()" v-if="isCreateUser">提 交</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { Editor } from "@/components/index.js";
import { formatEnToUtf8 } from "@/views/tops/devOps/components/util.js"

import {
  getDevOpsSpaceProducerListApi,
  getDevOpsSpaceReminderWorkOrderListlApi,
  getDevOpsSpaceWorkOrderDetailApi,
  postDevOpsSpaceCheckWorkOrderApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {getDevOpsSpaceAllUserListApi} from "@/server/tops/base";
export default {
  components: {Editor},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      form: {
        desc: '',
      },
      reminder_list:[],
      rules: {
        desc: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '135px',
      chainingLink: true,
      chainingLinkTo: true,
      loading: {
        dialog: false,
        submit: false,
      },
      workOrderDetail:{},
      userId:'',
      username:'',
    };
  },
  async mounted() {
    const { id = '', status = '',  name = '', next = false } = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';

    this.form = { ...this.form, id, status, name}
    this.$set(this.form, 'username', username)
    this.username = username;

    if(this.$store.state.devOps.userInfo.userId){
      this.userId = this.$store.state.devOps.userInfo.userId;
    }

    //获取未开始，进行中的项目
    this.$nextTick(async () => {
      await this.getWorkOrderInfo();
      await this.getReminderWorkOrderListlApi();
    })
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
        }
    ),
    isAdmin(){
      if(this.username){
        if(this.allUserList.ALLUSERTYPE13 && this.allUserList.ALLUSERTYPE13[this.username]) return true
      }
      return false;
    },
    isCreateUser(){
      if(this.isAdmin) return true;
      if(this.workOrderDetail.creator_id){
        return this.workOrderDetail.creator_id.id === this.userId;
      }
      return false;
    },
    newTitle() {
        return '[' + this.formInfo.id + ']催单-' + this.formInfo.title;
    },
  },
  methods: {
    // 获取详情
    async getWorkOrderInfo() {
      const ret = await getDevOpsSpaceWorkOrderDetailApi({work_id:this.formInfo.id });
      const info = ret.data || {};
      this.workOrderDetail = {
        ...info,
        type:info.type_code?info.type_code.toString(): '0',
        accepted_user_id:info?.acceptor_id?.id??'0',
        classify:info.classify_code?info.classify_code.toString():'0',
        level: info.level_code?info.level_code.toString():'0',
      };
    },
    async getReminderWorkOrderListlApi() {
      await getDevOpsSpaceReminderWorkOrderListlApi({workId: this.formInfo.id, type: '2'}).then((res) => {
        if(res.status === 'success'){
          this.reminder_list = res.data;
        }

      })
    },
    onSubmit(){
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.form.workId= this.workId;
          try {
            this.$set(this.loading, 'submit', true)
            postDevOpsSpaceCheckWorkOrderApi({...this.form,type:'1',workId:this.formInfo.id}).then((ret)=>{
              if (ret.status === 'success') {
                this.$notify({
                  message: ret.message || '提交成功',
                  type: "success",
                })
                setTimeout(() => {
                  this.handleClose()
                }, 500)
              } else {
                this.loading.submit = false;
                this.$notify({
                  message: ret.message || "失败",
                  type: "error",
                })
              }
            })
          }catch (error) {
            this.loading.submit = false;
            this.$notify({
              message: error || "网络错误",
              type: "error",
            })
          }finally {
            this.loading.submit = false;
          }

        }
      });

    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      let h = today.getHours() < 10 ? '0'+today.getHours() : today.getHours();
      let m = today.getMinutes() < 10 ? '0'+today.getMinutes() : today.getMinutes();
      let s = today.getSeconds() < 10 ? '0'+today.getSeconds() : today.getSeconds();
      return year + "-" + cmonth + "-" + cday + " " + h + ":" + m + ":" + s;
    },
    getDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
  }
};
</script>
<style lang="scss">
.demand_model_dialog {
  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
}

.re_list {
  max-height: 25vh;
  overflow-y: auto;
  white-space: pre-wrap;
  /* background: #f1fbec; */
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
  line-height: 24px;
  padding: 10px;
}
</style>
